module.exports = __webpack_public_path__ + "img/mzyygl.4b2eeab6.png";